$(window).on('scroll', () => {
  const scrollValue = $(window).scrollTop();
  if (scrollValue > 36) {
    $('.navbar').addClass('navbar--sticky');
  } else {
    $('.navbar').removeClass('navbar--sticky');
  }
});

const openMenu = () => $('body').addClass('nav-is-open');
const closeMenu = () => $('body').removeClass('nav-is-open');

$('body').on('click', '.navbar-toggler', () => {
  if ($('body').hasClass('nav-is-open')) {
    return closeMenu();
  }
  return openMenu();
});

function navbarSub() {
  let distance = 0;
  const navbarBasic = $('.block--basic');
  const navbarIcons = $('.block--icons');
  const navbarArrows = $('.block--arrow');

  if (navbarBasic.length) {
    distance = navbarBasic.offset().top - 54;
    if ($(this).scrollTop() >= distance) {
      navbarBasic.addClass('block--basic--sticky');
      $('.navbar').addClass('navbar--hidden');
    } else {
      navbarBasic.removeClass('block--basic--sticky');
      $('.navbar').removeClass('navbar--hidden');
    }
  } else if (navbarIcons.length) {
    distance = navbarIcons.offset().top - 54;
    if ($(this).scrollTop() >= distance) {
      navbarIcons.addClass('block--icons--sticky');
      $('.navbar').addClass('navbar--hidden');
    } else {
      navbarIcons.removeClass('block--icons--sticky');
      $('.navbar').removeClass('navbar--hidden');
    }
  } else if (navbarArrows.length) {
    distance = navbarArrows.offset().top - 54;
    if ($(this).scrollTop() >= distance) {
      navbarArrows.addClass('block--arrow--sticky');
      $('.navbar').addClass('navbar--hidden');
    } else {
      navbarArrows.removeClass('block--arrow--sticky');
      $('.navbar').removeClass('navbar--hidden');
    }
  }
}

$(window).scroll(() => {
  navbarSub();
});
